<template>
    <div class="paginationArea d-flex align-items-center">
        <template v-if="1==mode">
            <PaginationUtil ref="paginationUtil" :totalPageNum="totalPageNum" :mode="1" @pageNumberClicked="onPageNumberClick" />
        </template>
        <template v-else>
            <span>1ページに</span>
            <div class="select-icon" style="margin: 0px 8px;">
                <select class="input-text-scv" style="min-width: 80px;" @change="onSelectChange">
                    <option v-for="data in selectChangeList" v-bind:value="data" v-bind:key="data.id">{{ data }}</option>
                </select>
            </div>

            <span style="margin-right: 24px">件表示</span>
            <PaginationUtil ref="paginationUtil" :totalPageNum="totalPageNum" @pageNumberClicked="onPageNumberClick" />
            <div class="ms-auto">{{startItemNumber}}-{{endItemNumber}}件表示中/全{{totalItemNum}}件</div>
            <template v-if="antivirusSoftware===true">
                <span>(パターンファイル未更新台数：{{ notSolvedAntivirusSoftwareCount }}台)</span>
            </template>
        </template>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import PaginationUtil from '@/components/PaginationUtil.vue';

    @Options({
        components: {
            PaginationUtil,
        },
        props: {
            totalPageNum: Number,
            antivirusSoftware: Boolean,
            notSolvedAntivirusSoftwareCount: Number,
            totalItemNum: Number,
            startItemNumber: Number,
            endItemNumber: Number,
            selectChangeList: { type: Array, default: [20, 50, 100, 500, 1000] },
            mode: { type: Number, default: 0 }, // 0：いつもの 1：スリム表示
        },
    })

    export default class PaginationArea extends Vue {

        // ウイルス対策ソフトページ用
        private antivirusSoftware!: boolean;
        private notSolvedAntivirusSoftwareCount!: number;
        private selectChangeList!: Array<number>;

        public onPageNumberClick(pageNumber: number): void {
            this.$emit("pageNumberClicked", pageNumber);
        }

        /**
         * @brief	表示件数Select変更イベント
         * @param   [in]    event           イベント
         * @return	なし
         */
        public onSelectChange(event: any) {
            const selectedMaxPageItemNum: number = parseInt(event.target.value);
            this.$emit("onMaxPageItemNumSelectChange", selectedMaxPageItemNum);
        }

        /**
         * @brief	ページ番号をリセットする。
         * @return	なし
         */
        public resetPageNumber(): void {
            const refObj: any = this.$refs;
            refObj.paginationUtil.resetPageNumber();
        }

        /**
         * @brief	ページ番号を設定する
         * @return	なし
         */
        public setPageNumber(pageNumber: number): void {
            const refObj: any = this.$refs;
            refObj.paginationUtil.setPageNumber(pageNumber);
        }
    }
</script>

<style scoped>
    .paginationArea {
        font-size: 13px;
    }
</style>